import { Map } from 'immutable';
import { createAction, handleActions } from 'redux-actions';
export const actions = {
    IS_ORGANIZATION: createAction('GLOBAL/ACCOUNT/IS_ORGANIZATION'),
};
export const initialState = Map({
    isOrganization: false,
});
const reducer = handleActions({
    [actions.IS_ORGANIZATION]: (state, action) => state.set('isOrganization', action.payload),
}, initialState);
export default reducer;
